export default __webpack_public_path__ + "jokey.png";